import { render, staticRenderFns } from "./DeleteInstagramAccountModal.vue?vue&type=template&id=52b1746c&scoped=true&"
import script from "./DeleteInstagramAccountModal.vue?vue&type=script&lang=js&"
export * from "./DeleteInstagramAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteInstagramAccountModal.vue?vue&type=style&index=0&id=52b1746c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b1746c",
  null
  
)

export default component.exports